// extracted by mini-css-extract-plugin
module.exports = {"errorcontainer":"_2zb6X","close":"FlLN4","container":"_1PHwA","erroricon":"_2EdPh","text":"kJzqQ","call":"_3c3yQ"};